<template>
    <div class="themeList">
        <div class="tabs">
            <ul class="lists" id='list' ref="tab">
                <li v-for="(item,i) in this.navLists" :key="i" v-bind:class='{ lists_active: currentIndex == i} '
                    @click="clickCate(i)">
                    <router-link tag="div" :to="item.to">
                        <span class="tab-link">{{$t(item.title)}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "themeList",
        data() {
            return {
                navLists: [
                    {
                        to: '/themeScream',
                        title: 'theme[0]'
                    },
                    {
                        to: '/themePark',
                        title: "theme[1]",
                    },
                    {
                        to: '/themeHoliday',
                        title: "theme[2]",
                    },
                    {
                        to: '/themeMilitary',
                        title: "theme[3]",
                    }, {
                        to: '/themeFarmhouse',
                        title: "theme[4]",
                    },
                    {
                        to: '/themeSea',
                        title: "theme[5]",
                    },
                    {
                        to: '/themeWetland',
                        title: "theme[6]",
                    }],
                currentIndex: '',
            }
        },
        created() {
            this.currentIndex = this.$store.state.park.park_index;
        },
        methods: {
            clickCate(i) {
                this.currentIndex = i;
                this.$store.commit('set_park_index', i);
                // 发送请求获取数据
            },
            _initScroll() {
                let tabs = this.$refs.tab;
                let child0 = tabs.childNodes[0].clientWidth;
                let child1 = tabs.childNodes[1].clientWidth;
                let child2 = tabs.childNodes[2].clientWidth;
                let child3 = tabs.childNodes[3].clientWidth;
                let child4 = tabs.childNodes[4].clientWidth;
                let child5 = tabs.childNodes[5].clientWidth;
                let child6 = tabs.childNodes[6].clientWidth;
                let cWidth = document.documentElement.clientWidth;
                switch (this.park_index) {
                    case 0:
                        tabs.scrollLeft = 0;
                        break;
                    case 1:
                        tabs.scrollLeft = 0;
                        break;
                    case 2:
                        let _c2 = child0+child1;
                        if(_c2 > (cWidth- child2)/2){
                            tabs.scrollLeft =_c2-(cWidth- child2)/2;
                        }else {
                            tabs.scrollLeft=0
                        }
                        break;
                    case 3:
                        let _c3 = child0+child1 +child2;
                        if(_c3 > (cWidth- child3)/2){
                            tabs.scrollLeft =_c3- (cWidth- child3)/2;
                        }else{
                            tabs.scrollLeft=0
                        }
                        break;
                    case 4:
                        let _c4 = child0+child1 +child2 +child3;
                        tabs.scrollLeft =_c4- (cWidth- child4)/2;
                        break;
                    case 5:
                        let _c5 = child0+child1 +child2 +child3 +child4;
                        tabs.scrollLeft =_c5- (cWidth- child5)/2;
                        break;
                    case 6:
                        let _c6 = child0+child1 +child2 +child3 +child4+child5;
                        tabs.scrollLeft =_c6- (cWidth- child6)/2;
                        break;
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this._initScroll();
            })
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            },

            park_index() {
                return this.$store.state.park.park_index;
            }
        },


    }
</script>

<style scoped lang="less">
    @import "../../assets/less/nav";

    .themeList {
        position: relative;
        width: 100%;
        .tabs {
            width: 100%;
            box-sizing: border-box;
            white-space: nowrap;

        }
    }

    .lists li.lists_active {
        color: #feb302;
        &:after {
            background: #feb302;
        }
    }

</style>
